// Esporta tutti i servizi in un unico punto
export { default as apiService } from './api.service';
export { default as userService } from './user.service';
export { default as pinsService } from './pins.service';
export { default as billingService } from './billing.service';
export { default as chatService } from './chat.service';
export { default as geocodingService } from './geocoding.service';
export { default as notificationService } from './notification.service';
export { default as referralService } from './referral.service';
export { default as welcomeService } from './welcome.service';

// Esporta i tipi utili
export type { ApiResponse } from './api.service';
export type { PinnerProData, PinnerCredits } from '../interfaces/Pinners';
export type { RefillDataProps, ChartDataProps, ConsultancyDataProps } from '../interfaces/Billing';
export type { ChatMessage, ChatConversation } from '../interfaces/Chat';
export type { PlaceOption, GeocodingResult, LocalizationResult } from './geocoding.service';
export type { ReferralProp, ReferralItem, ReferralStatus } from '../interfaces/Referral';
export type { WelcomeData, WelcomeResponse, UserData } from '../interfaces/Welcome';
export type { RegisterPayload, RegisterResponse } from '../interfaces/Register';

// Funzione helper per invalidare tutta la cache
export const clearAllCache = async () => {
  console.log('🧹 Clearing all service caches...');

  // Import dinamico per evitare circular dependencies
  const { default: userService } = await import('./user.service');
  const { default: pinsService } = await import('./pins.service');
  const { default: billingService } = await import('./billing.service');
  const { default: chatService } = await import('./chat.service');
  const { default: geocodingService } = await import('./geocoding.service');
  const { default: referralService } = await import('./referral.service');
  const { default: notificationService } = await import('./notification.service');

  userService.clearCache();
  pinsService.clearCache();
  billingService.clearCache();
  chatService.clearCache();
  geocodingService.clearCache();
  referralService.clearCache();
  notificationService.clearCache();
  console.log('✅ All caches cleared');
};
